module.exports = __webpack_public_path__ + "img/DV_VAN_TAI.eafc994d.svg";